import { FeatureFlags } from './feature-flags-loader';

export class FeatureFlagsServiceBase {
    private _flags: FeatureFlags | null = null;

    public set flags(val) {
        if (this._flags) return;

        this._flags = val;
    }

    public get flags(): FeatureFlags {
        if (!this._flags) throw new Error('Feature flags not set yet');
        return this._flags;
    }
}
